
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTapPaymentCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationToken"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationTokenIos"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationTokenAndroid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKey"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKeyIos"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKeyAndroid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tapPlatformId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationToken"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationTokenIos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationTokenIos"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationTokenAndroid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationTokenAndroid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationPublicKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKey"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationPublicKeyIos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKeyIos"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapAuthenticationPublicKeyAndroid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapAuthenticationPublicKeyAndroid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tapPlatformId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tapPlatformId"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentGatewayCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationTokenIos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationTokenAndroid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationPublicKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationPublicKeyIos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapAuthenticationPublicKeyAndroid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tapPlatformId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1017}};
    doc.loc.source = {"body":"mutation updateTapPaymentCredentials(\n  $tapAuthenticationToken: String\n  $tapAuthenticationTokenIos: String\n  $tapAuthenticationTokenAndroid: String\n  $tapAuthenticationPublicKey: String\n  $tapAuthenticationPublicKeyIos: String\n  $tapAuthenticationPublicKeyAndroid: String\n  $tapPlatformId: String\n) {\n  updateConfigurations(\n    input: {\n      tapAuthenticationToken: $tapAuthenticationToken\n      tapAuthenticationTokenIos: $tapAuthenticationTokenIos\n      tapAuthenticationTokenAndroid: $tapAuthenticationTokenAndroid\n      tapAuthenticationPublicKey: $tapAuthenticationPublicKey\n      tapAuthenticationPublicKeyIos: $tapAuthenticationPublicKeyIos\n      tapAuthenticationPublicKeyAndroid: $tapAuthenticationPublicKeyAndroid\n      tapPlatformId: $tapPlatformId\n    }\n  ) {\n    paymentGatewayCode\n    tapAuthenticationToken\n    tapAuthenticationTokenIos\n    tapAuthenticationTokenAndroid\n    tapAuthenticationPublicKey\n    tapAuthenticationPublicKeyIos\n    tapAuthenticationPublicKeyAndroid\n    tapPlatformId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["updateTapPaymentCredentials"] = oneQuery(doc, "updateTapPaymentCredentials");
        
